import { useState } from 'react'

import { GAME_TYPE } from 'constants/enums/GameTypeEnum'

import { BuildingBlocksPromptResponse } from './ideaModels'

type Conversation = {
	content: string
	role: string
}

export const userMessage: Conversation = {
	content: '',
	role: 'user',
}

export const updateAIResponse = (content: string): Conversation => {
	return {
		content,
		role: 'assistant',
	}
}

export function BuildingBlocksModel() {
	const [authorIdeation, setAuthorIdeation] = useState<string>('')
	const [companyProblem, setCompanyProblem] = useState<string>('')
	const [gameId, setGameId] = useState<string | null>(null)
	const [innovationCompany, setInnovationCompany] = useState<string>('')
	const [innovationTopic, setInnovationTopic] = useState<string>('')
	const [termsAgreed, setTermsAgreed] = useState(false)
	const [promptConversation, setPromptConversation] = useState<
		Conversation[]
	>([])

	const submitIdeasDisabled = () =>
		generateScenarioDisabled() ||
		!authorIdeation ||
		(typeof gameId === 'string' && !termsAgreed)

	const generateScenarioDisabled = () =>
		[innovationTopic, innovationCompany, companyProblem].some(
			(field) => !field.length
		)
	const gameTypeId = GAME_TYPE.BUILDING_BLOCKS.value

	const [buildingBlocksPrompt, setBuildingBlocksPrompt] =
		useState<BuildingBlocksPromptResponse>()

	const setPromptResponse = (response: BuildingBlocksPromptResponse) => {
		setBuildingBlocksPrompt(response)
	}

	const updateCompanyAdvice = async () => {}

	const promptToJSON = () => {
		return {
			innovationTopic,
			innovationCompany,
			companyProblem,
			conversation: promptConversation,
		}
	}

	const gameToJSON = () => {
		return {
			gameId: gameId !== null ? gameId : undefined,
			gameTypeId,
			innovationTopic,
			innovationCompany,
			innovationTopicManual: companyProblem,
			authorIdeation,
		}
	}

	const reset = () => {
		resetSoft()
		setPromptConversation([])
	}

	const resetSoft = () => {
		setAuthorIdeation('')
	}

	return {
		authorIdeation,
		setAuthorIdeation,
		innovationCompany,
		setInnovationCompany,
		companyProblem,
		setCompanyProblem,
		innovationTopic,
		setInnovationTopic,
		setGameId,
		generateScenarioDisabled,
		gameToJSON,
		updateCompanyAdvice,
		termsAgreed,
		setTermsAgreed,
		submitIdeasDisabled,
		promptToJSON,
		setPromptResponse,
		buildingBlocksPrompt,
		reset,
		promptConversation,
		setPromptConversation,
		resetSoft,
	}
}
